import { SET_PROBLEM_SCALING } from './constants';

export const setScaling = (scaling: number) => {
    return { type: SET_PROBLEM_SCALING, scaling } as const;
};
